import React from 'react';
import { cn } from '../../lib/utils';
import KlLogoMark, { BRAND_TEXT_CLASS } from './KlLogoMark';

const WORDMARK_MOTION_CLASS =
  'transition-[max-width,opacity,transform] duration-200 ease-in-out motion-reduce:transition-none';

/**
 * Presentational KadelLabs brand lockup.
 *
 * @param {'mark' | 'full'} variant — icon only, or icon + wordmark (static)
 * @param {boolean} [expanded] — when used with `animate`, toggles wordmark visibility
 * @param {boolean} [animate=false] — keep wordmark in DOM and animate expand/collapse
 * @param {string} [className]
 * @param {boolean} [showTagline=false] — "serving through technology"; expanded sidebar (≥216px) only
 */
export default function BrandLogo({
  variant = 'mark',
  expanded: expandedProp,
  animate = false,
  className,
  showTagline = false,
}) {
  const expanded = expandedProp ?? variant === 'full';
  const showWordmark = animate ? true : expanded;
  const wordmarkVisible = expanded;

  return (
    <div
      className={cn(
        'flex min-w-0 items-center',
        animate ? (expanded ? 'gap-2' : 'justify-center') : variant === 'mark' ? 'justify-center' : 'gap-2',
        className
      )}
    >
      <KlLogoMark
        decorative={wordmarkVisible}
        className="h-7 w-7 max-md:h-6 max-md:w-6 shrink-0 md:h-8 md:w-8 lg:h-8 lg:w-8"
      />
      {showWordmark ? (
        <div
          className={cn(
            'flex min-w-0 flex-col justify-center overflow-hidden leading-tight',
            animate && WORDMARK_MOTION_CLASS,
            animate && (wordmarkVisible ? 'max-w-[9rem] opacity-100 translate-x-0' : 'max-w-0 opacity-0 -translate-x-1'),
            !animate && !wordmarkVisible && 'hidden'
          )}
          aria-hidden={animate && !wordmarkVisible ? true : undefined}
        >
          <span className={cn('truncate font-bold text-ds-h3', BRAND_TEXT_CLASS)}>KadelLabs</span>
          {showTagline && wordmarkVisible ? (
            <span
              className={cn(
                'truncate text-ds-caption italic',
                'text-[#0d2c7a]/80 dark:text-[#6ba3e8]/80'
              )}
            >
              serving through technology
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
